import { DispatchCard } from 'src/entities/dispatch';

/**
 * この回転で回る納品先の数。
 *
 * 伝票数ではなく地点数を数える。1 地点に伝票が複数ぶら下がるのが普通なので、
 * 伝票数を出すと「何軒回るのか」が読めない。
 *
 * 同一性は座標優先（地点集約の既定の規則）。座標が欠けている行は名称で切る。
 * 座標だけで判定すると、座標欠損のカードが全部 1 件に潰れる。
 */
export function countDeliveryDestinations(cards: DispatchCard[]): number {
  const seen = new Set<string>();
  cards.forEach((card) => {
    if (card.type !== 'delivery') return;
    const geo = card.geo;
    seen.add(geo ? `geo:${geo.lat},${geo.lng}` : `name:${card.storeName}`);
  });
  return seen.size;
}
